// @flow
import React, {useCallback, useState} from 'react';

import {navigate} from '../../lib/helpers';
import {expertiseServiceGpmCostApi} from '../../lib/api';
import {type ExpertiseServiceGpmCost} from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import {InnerForm} from './components';
import {getBreadCrumbsByUrlForEdit} from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/expertise-service-gpm-cost/';

export default (props: PageProps) => {
  const [data: ExpertiseServiceGpmCost, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, data.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await expertiseServiceGpmCostApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: ExpertiseServiceGpmCost) => {
    let id = payload.id;
    if (id) {
      await expertiseServiceGpmCostApi.update(payload);
    } else {
      let data = await expertiseServiceGpmCostApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async () => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость ТО ГПМ и промышленной экспертизы'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
